import fetchClient from '../utils/fetchClient';

// Получить посты со стены пользователя
export const getUserWallPosts = async (userId) => {
    const response = await fetchClient.get(`/wall-posts/user/${userId}`);
    return response;
};

// Получить свои посты на стене
export const getMyWallPosts = async () => {
    const response = await fetchClient.get('/wall-posts/my');
    return response;
};

// Добавить подарок на стену
export const addToWall = async (imageRelationId, isPublic = true) => {
    const response = await fetchClient.post('/wall-posts', {
        image_relation_id: imageRelationId,
        is_public: isPublic
    });
    return response;
};

// Удалить подарок со стены
export const removeFromWall = async (wallPostId) => {
    const response = await fetchClient.delete(`/wall-posts/${wallPostId}`);
    return response;
};

// Удалить подарок со стены по image_relation_id
export const removeFromWallByImageRelation = async (imageRelationId) => {
    const response = await fetchClient.delete(`/wall-posts/by_image_relation/${imageRelationId}`);
    return response;
};

// Изменить видимость поста на стене
export const toggleWallPostVisibility = async (wallPostId, isPublic) => {
    const response = await fetchClient.put(`/wall-posts/${wallPostId}/visibility`, {
        is_public: isPublic
    });
    return response;
};

// Клейм расшаренной открытки на стену
export const claimPostcard = async (shareId) => {
    const response = await fetchClient.post('/wall/claim', {
        share_id: shareId
    });
    return response;
};

// Отметить открытку как просмотренную
export const markWallPostViewed = async (imageRelationId) => {
    const response = await fetchClient.put(`/wall-posts/mark-viewed-by-postcard/${imageRelationId}`);
    return response;
};

// Получить количество непросмотренных
export const getUnviewedCount = async () => {
    const response = await fetchClient.get('/wall-posts/my/unviewed-count');
    return response;
};
